import { SAVE_QUERYINFO, INIT_STATE } from './action';

const initialState = {
  psgName: '',
  ticketNo: '',
  ticketPrice: '',
  taxFee: '',
  refundChangeRule: '',
  rules: [],
  segment: [],
  isTicketNoFlag: '0', // 0 票号 1 证件号
  ticketInfos: [],
  mileageTicket:'',
  volunteer: true, // true 自愿 false 非自愿
};

export default function feeQueryReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_STATE:
      return initialState;
    case SAVE_QUERYINFO:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/feeQuery/modules/feeQuery.js